<template>
  <div class="item" :class="itemClass" ref="item">
    <div class="text-box">
      <h4>{{date}}</h4>
      <p v-html="description"></p>
      <a :href="link" :class="'align-' + linkPosition" target="_blank"></a>
    </div>
  </div>
</template>

<script>
  export default {
    name: "TimelineItem",
    props: {
      date: {
        type: String
      },
      description: {
        type: String
      },
      link: {
        type: String,
        default: '#'
      },
      align: {
        type: String,
        default: 'bottom'
      },
      linkPosition: {
        type: String,
        default: 'bottom'
      }
    },
    data() {
      return {
        inViewport: false
      }
    },
    computed: {
      itemClass() {
        let c = this.align;
        if (this.inViewport) {
          c += ' in-viewport';
        }
        return c;
      }
    },
    methods: {
      checkObserver() {
        if (window["IntersectionObserver"]) {
          this.createObserver();
        } else {
          this.inViewport = true;
        }
      },
      createObserver() {
        const item = this.$refs.item;
        const options = {
          root: null,
          threshold: 0.5
        };
        const observer = new IntersectionObserver(this.handleIntersect, options);
        observer.observe(item);
      },
      handleIntersect(intersection) {
        if (intersection[0].isIntersecting) {
          this.inViewport = true;
        }
      }
    },
    mounted() {
      this.checkObserver();
    }
  }
</script>

<style scoped>
  .item {
    position: relative;
    color: white;
    max-width: 260px;
    width: 260px;
    margin: -14px 70px;
    padding: 1px 0;
    display: inline-block;
    white-space: normal;
  }
  .item:before {
    content: "";
    position: relative;
    display: block;
    width: 29px;
    height: 29px;
    border-radius: 50%;
    background-color: white;
    margin: 0 -2px 16px;
    transform: scale(0);
    transition: 0.4s cubic-bezier(0.33, 1, 0.68, 1) 0s;
  }
  .text-box {
    opacity: 0;
    transform: translate3d(200px, 0, 0);
    transition: 0.5s cubic-bezier(0.33, 1, 0.68, 1) 0.2s;
  }
  .item.in-viewport .text-box {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
  .item.in-viewport:before {
    transform: scale(1);
  }
  .item.right {
    position: absolute;
    margin-left: 33px;
  }
  .item.right:before {
    position: absolute;
    left: -44px;
  }
  .item.top {
    transform: translate3d(0, calc(-100% - 12px), 0);
    margin-right: -100px;
  }
  .item.top:before {
    position: absolute;
    top: 100%;
    margin-top: 12px;
  }
  .item.top a.align-left {
    top: 13px;
  }
  h4 {
    font-size: 12px;
    font-weight: 500;
  }
  h4, p {
    margin: 6px 0;
  }
  p {
    font-size: 20px;
    line-height: 1.4;
  }
  a {
    position: relative;
    display: block;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: 3px solid white;
    margin: 20px -2px 2px;
    overflow: hidden;
  }
  a.align-left {
    position: absolute;
    right: 100%;
    margin-right: 20px;
    top: 54px;
  }
  a:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(./../assets/images/arrow-link.svg);
    transform: translate3d(-30%, 0, 0);
    transition: 0.2s ease;
  }
  a:hover:after {
    transform: translate3d(-15%, 0, 0);
  }
  @media(min-width: 1000px) and (max-height: 800px) {
    .item {
      min-width: 220px;
    }
    p {
      font-size: 17px;
      line-height: 1.3;
      min-height: 90px;
    }
  }
  @media(max-width: 999px), (max-height: 800px) {
    p {
      font-size: 16px;
      min-height: 0;
    }
    a {
      border: 2px solid white;
      width: 40px;
      height: 40px;
      margin-top: 14px;
    }
    .item {
      width: 200px;
      margin-right: 40px;
    }
    .item.top {
      width: 240px;
      margin-right: -150px;
    }
    .item:before {
      width: 28px;
      height: 28px;
    }
  }
</style>